import React from 'react';

const FlipBookViewer = () => {
  return (
    <div style={{ width: '100%', height: '100vh' }}>
        
      <iframe
        src="https://heyzine.com/flip-book/c1a13e8fd9.html"
        style={{ width: '100%', height: '100%' }}
        title="Flip Book Viewer"
        frameBorder="0"
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default FlipBookViewer;
